import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getFeedsThunk } from '../../actions/feeds';
import { FeedsContentWithLoader } from './loaders';

export const Feeds = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getFeedsThunk({}));
    }, []);

    return (
        <FeedsContentWithLoader />
    );
};
